export default __webpack_public_path__ + "static/media/Broa-Amarelo.8f33a20a.jpg";